
document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".digital-form");
  const wrapper = document.querySelector("#form1-content");

  form.addEventListener("submit", function (e) {
    e.preventDefault(); // stop actual submission

    wrapper.innerHTML = `
      <p>Thank you for requesting a digital copy of our brochure.<br><br>
      You should have received an email with a link to view the brochure.
      Please check your junk folder in case it's landed in there.
      Enjoy browsing our collections.<br><br>
      You can also view the brochure <a style="text-decoration:underline" href="https://cdn.shopify.com/s/files/1/0916/1080/8701/files/Terzetto-Stone_Collections-Brochure.pdf?v=1764595784">here.</a></p>
    `;
  });
});



document.addEventListener("DOMContentLoaded", function () {
  
  const form2 = document.querySelector(".brochure-form");
  const wrapper2 = document.querySelector("#form2-content");

  form2.addEventListener("submit", function (e) {
    e.preventDefault(); // prevent page reload

    // Replace form with thank-you message
    wrapper2.innerHTML = `
      <p>
        Thank you for requesting a paper brochure. 
        We will get this posted out to you straight away.<br><br>
        In the meantime you can carry on browsing our ranges online. 
        Don't forget you can order up to four free samples through our website.
      </p>
    `;
  });

});



  const form1Toggle = document.getElementById('form1-toggle');
  const form2Toggle = document.getElementById('form2-toggle');
  const form1Content = document.getElementById('form1-content');
  const form2Content = document.getElementById('form2-content');

  form1Toggle.addEventListener('change', function () {
    form1Content.classList.add('active');
    form2Content.classList.remove('active');
  });

  form2Toggle.addEventListener('change', function () {
    form2Content.classList.add('active');
    form1Content.classList.remove('active');
  });



  document.addEventListener("DOMContentLoaded", function() {
    // 1. Target the specific <select> element. 
    // IMPORTANT: Give your select element an ID (e.g., 'country-select') 
    // or a specific class to ensure this script targets the correct one.
    const countrySelect = document.querySelector('select'); // Target the first select found, or be more specific:
    // const countrySelect = document.getElementById('country-select'); 

    if (!countrySelect) {
        console.error("Country select element not found.");
        return;
    }

    // 2. Define a list of countries (using ISO 3166-1 names for consistency)
    const countries = [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", 
        "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", 
        "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", 
        "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", 
        "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", 
        "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", 
        "Chile", "China", "Colombia", "Comoros", "Congo (Brazzaville)", 
        "Congo (Kinshasa)", "Costa Rica", "Croatia", "Cuba", "Cyprus", 
        "Czechia", "Denmark", "Djibouti", "Dominica", "Dominican Republic", 
        "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", 
        "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", 
        "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", 
        "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", 
        "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", 
        "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", 
        "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", 
        "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", 
        "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", 
        "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", 
        "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", 
        "Myanmar (Burma)", "Namibia", "Nauru", "Nepal", "Netherlands", 
        "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", 
        "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine State", 
        "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", 
        "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", 
        "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", 
        "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", 
        "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", 
        "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", 
        "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", 
        "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", 
        "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", 
        "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", 
        "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", 
        "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", 
        "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
    ];

    // 3. Clear existing options
    countrySelect.innerHTML = ''; 

    // 4. Add a default/placeholder option
    const defaultOption = document.createElement('option');
    defaultOption.value = "";
    defaultOption.textContent = "Select a Country";
    defaultOption.disabled = true;
    defaultOption.selected = true;
    countrySelect.appendChild(defaultOption);

    // 5. Loop through the array and create <option> tags
    countries.forEach(country => {
        const option = document.createElement('option');
        // It's best practice for the value to be a standardized format (e.g., lowercase, no spaces, or a code)
        // For simplicity, we use the full name as the value here.
        option.value = country; 
        option.textContent = country;
        countrySelect.appendChild(option);
    });
});